import Vue from 'vue'

var directive = {
  
  // Bind a click action to activate/select the item
  inserted : (el, binding, vnode) => {

    el.addEventListener('mouseover', (e) => {
      log('mouseover');
      if( !vnode.context.isAuthenticated ) {
        return false;
      }
      vnode.context.hovering = true;
      // vnode.context.setHoverTimeout();
    }, false)

    el.addEventListener('mouseleave', (e) => {
      log('mouseleave');
      vnode.context.hovering = false;
      // vnode.context.clearHoverTimeout();
    }, false)

    el.addEventListener('click',(e) => {
      // vnode.context.setHoverTimeout();
    },false);
  },

};

// var debug = true;

function log(msg) {
  if( "undefined" !== typeof debug && debug ) {
    console.log('[ ToggleHover ] ' + msg )
  }
}

export var mixin = {
  directives: { 'toggle-hover': directive },

  data() {
    return  {
      hoverTimeout : null,
      hovering : false  
    }
  },
  computed: {
  },
  methods : {
    setHoverTimeout() {
      this.clearHoverTimeout();
      this.hoverTimeout = setTimeout( () => { this.hovering = false}, 1200)      
    }, // setHoverTimeout
    clearHoverTimeout() {
      clearTimeout( this.hoverTimeout );
    }
  }
}

export default mixin;


// WEBPACK FOOTER //
// ./src/toggle-hover/index.js